import dashboardSlice from "../slices/dashboardSlice";

export const {
  RequestDashboard,
  setModalActive,
  setModalParams,
  SuccessDashboard,
  FailureDashboard,
  RequestNewFile,
  SuccessNewFile,
  FailureNewFile,
  RequestQuickSubmit,
  SuccessQuickSubmit,
  FailureQuickSubmit,
  CurrentNewFile,
  RequestNewScript,
  SuccessNewScript,
  FailureNewScript,
  RequestDailySubmissions,
  SuccessDailySubmissions,
  FailureDailySubmissions,
  RequestSubmissionsList,
  SuccessSubmissionsList,
  FailureSubmissionsList,
  RequestCloudList,
  SuccessCloudList,
  FailureCloudList,
  RequestAllSubmissions,
  SuccessAllSubmissions,
  FailureAllSubmissions,
  RequestMaliciousSubmissions,
  SuccessMaliciousSubmissions,
  FailureMaliciousSubmissions,
  RequestCleanSubmissionsState,
  SuccessCleanSubmissionsState,
  FailureCleanSubmissionsState,
  RequestSuspiciousSubmissionsState,
  SuccessSuspiciousSubmissionsState,
  FailureSuspiciousSubmissionsState,
  RequestMaliciousSubmissionsState,
  SuccessMaliciousSubmissionsState,
  FailureMaliciousSubmissionsState,
  SetSubmittedFile,
  CopyClipboard,
  RequestGroupVerdict,
  SuccessGroupVerdict,
  FailureGroupVerdict,
  RequestSubmitFreerun,
  SuccessSubmitFreerun,
  FailureSubmitFreerun,
  RequestToggleFavorite,
  RequestCleanRunningTab,
  RequestNewUrl,
  SuccessNewUrl,
  FailureNewUrl,
  ResetUrlError,
  RequestSetUILogo,
  SuccessSetUILogo,
  FailureSetUILogo,
  RequestGetUILogo,
  SuccessGetUILogo,
  FailureGetUILogo,
  RequestSubmissionsListForStats,
  SuccessSubmissionsListForStats,
  FailureSubmissionsListForStats,
  RequestRunningCount,
  SuccessRunningCount,
  FailureRunningCount,
  RequestRunningSubmissions,
  SuccessRunningSubmissions,
  FailureRunningSubmissions,
  RequestSearchCompletedSubmissions,
  SuccessSearchCompletedSubmissions,
  FailureSearchCompletedSubmissions,
  RequestIntegrationSubmissionCount,
  SuccessIntegrationSubmissionCount,
  FailureIntegrationSubmissionCount,
  RequestDailyIntegrationSubmissionCount,
  SuccessDailyIntegrationSubmissionCount,
  FailureDailyIntegrationSubmissionCount,
  RequestIntegrationSubmissionState,
  SuccessIntegrationSubmissionState,
  FailureIntegrationSubmissionState,
  RequestSearchGroupSubmissions,
  SuccessSearchGroupSubmissions,
  FailureSearchGroupSubmissions,
  RequestStaticSubmit,
  SuccessStaticSubmit,
  FailureStaticSubmit,
  RequestVms,
  SuccessVms,
  FailureVms,
  RequestAptCount,
  SuccessAptCount,
  FailureAptCount,
  RequestMalwareNameCounts,
  SuccessMalwareNameCounts,
  FailureMalwareNameCounts,
  RequestIntegrationMalwareNameCounts,
  SuccessIntegrationMalwareNameCounts,
  FailureIntegrationMalwareNameCounts,
  RequestDeleteSubmissionFromList,
  RequestResubmitSample,
  SuccessResubmitSample,
  FailureResubmitSample,
  RequestUniqueSubmissionsCount,
  SuccessUniqueSubmissionsCount,
  FailureUniqueSubmissionsCount,
  RequestDeleteBanner,
  SuccessDeleteBanner,
  FailureDeleteBanner,
  RequestNewBrowserUrl,
} = dashboardSlice.actions;
